import React from 'react';

export const SignatureElements = {
    Terminal:{},
    Certificate:{}
}

// export function LoadArkSigner() {
//     return new Promise((resolve, reject) => {
//         const script = document.createElement('script');
//         script.src = '/static/js/ArkSignerJS-2.1.0.4.min.js';
//         script.async = true;
//         script.onload = resolve; // Yükleme başarılı olduğunda Promise'i tamamla
//         script.onerror = reject; // Yükleme hatası olduğunda Promise'i reddet
//         document.body.appendChild(script);
//     });
// }

// export function LoadArkSigner(callback) {
export function LoadArkSigner() {
    let pwsigner ={};
    const script = document.createElement('script');
    script.src = '/static/js/ArkSignerJS-3.0.2.min.js';
    script.async = true;
    script.onload = () => {
        pwsigner = window.pwsigner;

        // Set ArkSigner license key.
        pwsigner.setLicenseKey(process.env.REACT_APP_ARKSIGNER_LICENCE);
        pwsigner.initialize(onPWSigner_Initialized);
    };
    document.body.appendChild(script);

    function onPWSigner_Initialized(code, json) {
        if (code == window.PWSigner.prototype.codes.RESPONSE_SUCCESSFUL) {
            pwsigner.smartCard.listTerminals(onPWSigner_ListTerminals, {});
        }
    }

    function onPWSigner_ListTerminals(code, json) {
        if (code == window.PWSigner.prototype.codes.RESPONSE_SUCCESSFUL) {
            var _terminals = pwsigner.parseJSON(json);

            Array.prototype.forEach.call(_terminals, element => {
                SignatureElements.Terminal={text:window.Base64.decode(element.terminal),value:window.Base64.decode(element.slotId) + ',' + window.Base64.decode(element.library)};
                pwsigner.smartCard.listCertificates(onPWSigner_ListCertificates, {
                    library: window.Base64.decode(element.library),
                    slotId: window.Base64.decode(element.slotId)
                });

            });
        }
    }

    function onPWSigner_ListCertificates(code, json) {
        if (code == window.PWSigner.prototype.codes.RESPONSE_SUCCESSFUL) {
            var _certificates = pwsigner.parseJSON(json);
            Array.prototype.forEach.call(_certificates, element => {
                SignatureElements.Certificate={text:window.Base64.decode(element.commonName),value:window.Base64.decode(element.serialNumber) + "," + hexToBase64(element.certificateHex)};
            });
        }
    }

    function hexToBase64(str) {
        return btoa(String.fromCharCode.apply(null,
            str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" "))
        );
    }
}